module.exports = __webpack_public_path__ + "static/media/callcancel.96a9e019.png";